// Make requests to CryptoCompare API
import { LocalStorage } from "quasar";
import useData from "src/use/data";

const { allSymbol } = useData();
export async function makeApiRequest() {
  try {
    const response = await allSymbol();
    const data = response.data.filter((item) => item.type != "sector");

    return data;
  } catch (error) {
    throw new Error(` request error: ${error.status}`);
  }
}
export function parseFullSymbol(fullSymbol) {
  // const match = fullSymbol.match(/^(\w+):(\w+)$/);
  // if (!match) {
  // return null;
  // }
  // return { exchange: match[1], fromSymbol: match[2] };
  return { exchange: fullSymbol, fromSymbol: fullSymbol };
}
// Generate a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
  const short = `${fromSymbol}`;
  let company = LocalStorage.getItem("company");
  if (company == "nepsesignal.com") {
    company = "Artha Sarorak";
  }
  if (company == "prabhu") {
    company = "Prabhu Capital";
  }
  if (company == "sweta.nepsesignal.com") {
    company = "Sweta Securities";
  }
  if (company == "localhost") {
    company = "chukul";
  }
  if (company == "demo1.nepsesignal.com") {
    company = "demo1";
  }
  return {
    short,
    full: `${toSymbol}` + " " + "(" + company + ")",
    exchange,
    type: exchange,
  };
}
